// @flow
import React, { Component } from 'react';
import { isBrowser } from 'react-device-detect';
import Button from 'components/common/Button';
import { type Profile } from 'store/modules/profile';
import { BaseActions } from 'store/actionCreators';

import './SettingProfile.scss';

type Props = {
  profile: Profile,
  user: any,
  onUpdateProfile: ({
    managerName: string,
    displayName: string,
    shortBio: string,
    mobile: string,
    bizNumber: string,
  }) => any,
  onUploadThumbnail: () => any,
  onUploadBizFile: () => any,
};

type State = {
  editing: boolean,
  managerName: string,
  displayName: string,
  shortBio: string,
  mobile: string,
  bizNumber: string,
};

class SettingProfile extends Component<Props, State> {
  state = {
    editing: false,
    managerName: '',
    displayName: '',
    mobile: '',
    bizNumber: '',
  };

  constructor(props: Props) {
    super(props);
    const { profile } = this.props;
    this.state.managerName = profile.manager_name;
    this.state.displayName = profile.display_name;
    this.state.shortBio = profile.short_bio;
    this.state.mobile = profile.mobile;
    this.state.bizNumber = profile.biz_number;
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.profile !== this.props.profile || (!prevState.editing && this.state.editing)) {
      const { manager_name, display_name, mobile, biz_number } = this.props.profile;
      this.setState({
        managerName: manager_name,
        displayName: display_name,
        mobile,
        bizNumber: biz_number,
      });
    }
  }

  onToggleEdit = (e: SyntheticEvent<*>) => {
    e.preventDefault();
    // this.setState({
    //   editing: !this.state.editing,
    // });
  };
  onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  onSubmit = async (e: SyntheticEvent<*>) => {
    e.preventDefault();
    const { managerName, displayName, mobile, bizNumber } = this.state;
    try {
      await this.props.onUpdateProfile({
        managerName,
        displayName,
        mobile,
        bizNumber,
      });
      // this.setState({
      //   editing: false,
      // });
      BaseActions.showToast({
        message: '프로필이 저장되었습니다.',
        type: 'success',
      });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { profile, onUploadThumbnail, onUploadBizFile } = this.props;
    const { editing, managerName, displayName, shortBio, mobile, bizNumber } = this.state;
    return (
      <div className="SettingProfile">
        <div className="profile-card">
          <div className="profile-header">
            <h2>프로필 설정</h2>
            <p>회원 정보를 관리하고 업데이트하세요</p>
          </div>

          <form onSubmit={this.onSubmit}>
            <div className="form-section">
              <div className="form-group">
                <span className="form-label">회원등급</span>
                <div className="form-display">
                  <span className="grade-badge">{this.props.user.grade.name}</span>
                </div>
              </div>

              <div className="form-group">
                <span className="form-label">이메일</span>
                <div className="form-display">
                  {this.props.user.email}
                </div>
              </div>

              <div className="form-group">
                <span className="form-label">비밀번호</span>
                <div className="password-section">
                  <span className="password-text">보안을 위해 정기적으로 비밀번호를 변경하세요</span>
                  <Button className="password-button" to={'/settings/password'}>비밀번호 변경</Button>
                </div>
              </div>
            </div>

            <div className="form-section">
              <div className="form-group">
                <label className="form-label" htmlFor="mobile">
                  연락처
                  <input
                    id="mobile"
                    className="form-input"
                    onChange={this.onChange}
                    name="mobile"
                    placeholder="연락처를 입력하세요"
                    value={mobile}
                    maxLength="40"
                    required
                  />
                </label>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="managerName">
                  이름
                  <input
                    id="managerName"
                    className="form-input"
                    onChange={this.onChange}
                    name="managerName"
                    placeholder="이름을 입력하세요"
                    value={managerName}
                    maxLength="25"
                    required
                  />
                </label>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="displayName">
                  회사명
                  <input
                    id="displayName"
                    className="form-input"
                    onChange={this.onChange}
                    name="displayName"
                    placeholder="회사 이름을 입력하세요"
                    value={displayName}
                    maxLength="25"
                    required
                  />
                </label>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="bizNumber">
                  사업자등록번호
                  <input
                    id="bizNumber"
                    className="form-input"
                    onChange={this.onChange}
                    name="bizNumber"
                    placeholder="사업자등록번호를 입력하세요 (선택사항)"
                    value={bizNumber}
                    maxLength="40"
                  />
                </label>
              </div>

              <div className="form-group">
                <span className="form-label">사업자등록증</span>
                <div className="file-upload-section">
                  <div className="upload-info">
                    <div className="upload-text">사업자등록증을 업로드하세요</div>
                    {profile.biz_file && (
                      <a className="file-link" href={profile.biz_file} target="_blank" rel="noopener noreferrer">
                        <span role="img" aria-label="문서 파일">📄</span> 업로드된 파일 보기
                      </a>
                    )}
                  </div>
                  <button className="upload-button" type="button" onClick={onUploadBizFile}>
                    파일 선택
                  </button>
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button className="submit-button" type="submit">
                회원 정보 수정
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default SettingProfile;



// WEBPACK FOOTER //
// ./src/components/settings/SettingProfile/SettingProfile.js